import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';

export const GenerateAndUploadPDF = async (elementRef, patientId, dialysisId, type) => {
    try {
        const canvas = await html2canvas(elementRef.current, {
            scale: 1.2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff'
        });

        const imgData = canvas.toDataURL('image/jpeg', 0.7);
        const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const imgX = (pdfWidth - imgWidth * ratio) / 2;
        const imgY = (pdfHeight - imgHeight * ratio) / 2;

        pdf.addImage(imgData, 'JPEG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
        const pdfBuffer = pdf.output('arraybuffer');

        const s3Client = new S3Client({
            region: 'ap-southeast-1',
            credentials: {
                accessKeyId: "Y0WWU13PSR9JMDUASN8V",
                secretAccessKey: "DF7tATk9SPB0aGkf8tzXkYcfHaBhl2BQzp3hRcm1",
            },
            endpoint: "https://s3.ap-southeast-1.wasabisys.com",
            forcePathStyle: true,
        });

        const timestamp = new Date().toISOString().split('.')[0].replace(/[:T]/g, '-');
        const fileName = `${dialysisId || 'unknown'}_${timestamp}.pdf`;
        const filePath = type !== 'tilt' ? `Peace Village/patient/${patientId}/dialysis_doc/${fileName}`
            : `Peace Village/patient/${patientId}/assessment_score/${type}/${fileName}`;

        const params = {
            Bucket: 'pvdev',
            Key: `${filePath}`,
            Body: new Uint8Array(pdfBuffer),
            ContentType: 'application/pdf',
        };

        await s3Client.send(new PutObjectCommand(params));

        const fileUrl = `https://s3.ap-southeast-1.wasabisys.com/pvdev/${filePath}`;

        return {
            success: true,
            document: {
                title: fileName,
                file_name: filePath,
                file_type: 'dialysis_doc',
                file_url: fileUrl
            }
        };

    } catch (error) {
        console.error('Error generating/uploading PDF:', error);

        let errorMessage = 'Error generating PDF';

        if (error.message) {
            errorMessage = error.message;
        }

        return {
            success: false,
            error: errorMessage
        };
    }
};